import { loadTemplate } from 'core-components/helpers/lazyLoad'
import { ILayoutSettings } from 'core-components/sitebuilder/models/ILayoutSettings'
import appSettings from 'src/config/settings'

export const loadSitePageSettings = async (): Promise<ILayoutSettings[]> => {
  const pageSettings = appSettings.sitePagesSettings.map(async (layout: any) => {
    if (!layout.properties) {
      const template = await loadTemplate(layout.template)
      const templateProperties = template?.default?.properties || {}
      return { ...layout, properties: templateProperties }
    }
    return layout
  })
  return await Promise.all(pageSettings)
}
